<template>
  <el-row :gutter="15">
    <el-col
      :xs="12"
      :sm="8"
      :md="7"
      :lg="6"
      :xl="4"
    >
      <el-card
        shadow="never"
        header="Lists"
      >
        <el-menu
          :default-active="activeList"
          class="border-0"
          @select="index => { activeList = index }"
        >
          <el-menu-item index="My Day">
            <FontAwesomeIcon
              :icon="[ 'fal', 'sun' ]"
              size="lg"
            />
            <span class="pl-3">My Day</span>
          </el-menu-item>

          <el-menu-item index="Trading Accounts">
            <FontAwesomeIcon
              :icon="[ 'fal', 'briefcase' ]"
              size="lg"
            />
            <span class="pl-3">Trading Accounts</span>
          </el-menu-item>

          <el-menu-item index="Opportunities">
            <FontAwesomeIcon
              :icon="[ 'fal', 'bullseye-arrow' ]"
              size="lg"
            />
            <span class="pl-3">Opportunities</span>
          </el-menu-item>
        </el-menu>
      </el-card>
    </el-col>

    <el-col
      :xs="12"
      :sm="16"
      :md="17"
      :lg="18"
      :xl="20"
    >
      <component
        :is="list"
        ref="list"
      />
    </el-col>
  </el-row>
</template>

<script>
import MyDayList from '@/components/Application/Sales/ToDo/MyDay'
import TradingAccountsList from '@/components/Application/Sales/ToDo/TradingAccounts'
import OpportunitiesList from '@/components/Application/Sales/ToDo/Opportunities'
import { CREATED, UPDATED, DELETED, RESTORED } from '@/plugins/sdk/Events'

const DEFAULT_LIST = 'My Day'

export default {
  data () {
    return {
      breadcrumb: {
        name: 'To-Do',
        route: { name: 'sales-todo' }
      },
      actions: [
        ...this.$parent.actions,
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ],
      activeList: undefined
    }
  },
  computed: {
    list () {
      switch (this.activeList) {
        case 'Trading Accounts':
          return TradingAccountsList
        case 'Opportunities':
          return OpportunitiesList
        case 'My Day':
          return MyDayList
        default:
          return undefined
      }
    }
  },
  watch: {
    activeList (value) {
      if (this.$route.query.list !== value) {
        this.$router.replace({ query: { list: value } })
      }
    }
  },
  created () {
    this.activeList = this.$route.query.list || DEFAULT_LIST
  },
  mounted () {
    this
      .$sdk
      .account_event
      .on([ CREATED, UPDATED, DELETED, RESTORED ], this.reload, this)
  },
  methods: {
    reload () {
      this.$refs['list'].reload()
    }
  }
}
</script>
